export default __webpack_public_path__ + "static/mumara-dcc4f6e9396a41fff397b000a649422b.png";